<template>
  <div>
    <card class="card" :title="title">
      <div class="card__right-button">
        <div class="position-relative">
          <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openModalCreate()">
            <i class="fas fa-plus"></i>
          </button>
          <div class="tooltipCustom tooltipCustom--bottom">Create new Member</div>
        </div>
      </div>
      <div v-if="members.length > 0">
        <ul class="list-unstyled team-members">
          <li>
            <div class="row" v-for="(member, index) in members" :key="member.index">
              <div class="col-sm-12 col-md-1">
                <div class="avatar">
                  <img :src="getImage(member)" alt="Circle Image" class="rounded img-fluid" />
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                {{ member.data.first_name }} {{ member.data.last_name }}
                <br />
                <span :class="getStatusClass(member.data.allow_log_in)">
                  <small>{{ getStatus(member) }}</small>
                </span>
              </div>
              <div class="col-sm-12 col-md-1">
                <router-link :to="'/companies/user/' + member.data.user_id">
                  <p-button type="success" outline icon>
                    <i class="fa fa-edit"></i>
                  </p-button>
                </router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div v-else>
        <p>{{ $t('this_company_does_not_have_any_users') }}</p>
      </div>
    </card>

    <ModalTemplate
      component-name="CreateUserModal"
      action="addUser"
      :data="{ header: 'Create new Member' }"
      button-component-name="CreateNewButton"
      :clicked="openCreate"
      @submit="updateListUsers($event)"
      @update:field="openCreate = false"
    >
    </ModalTemplate>
  </div>
</template>
<script>
import ModalTemplate from '../../../components/modals/ModalTemplate';
export default {
  components: { ModalTemplate },
  props: {
    members: {
      type: Array,
    },
  },
  data() {
    return {
      title: 'Team members',
      openCreate: false,
    };
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case 2:
          return 'text-muted';
        case 1:
          return 'text-success';
        case 0:
          return 'text-danger';
        default:
          return 'text-success';
      }
    },
    getImage(member) {
      let url = require('../../../assets/img/user_circle.jpeg');
      if (member.data.avatar) url = member.data.avatar;
      return url;
    },
    getStatus(member) {
      return member.data.allow_log_in === 1 ? 'Active' : 'Deactivated';
    },
    openModalCreate() {
      this.openCreate = true;
    },
    updateListUsers: function (event) {
      this.members.push(event);
    },
  },
};
</script>
<style></style>
